// extracted by mini-css-extract-plugin
export default {"appendum":"Appendum_appendum__-LVvq","left":"Appendum_left__gQTup","right":"Appendum_right__Oe4O2","text":"Appendum_text__3pKyJ","numaLogo":"Appendum_numaLogo__UMBlr"};